// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2PkhP","column":"style_column__1olvL","row":"style_row__1l6cU"};